import registrationInstance from '../../instance'

const getUsersPinCodesSettings = (module) => {
  return registrationInstance.get(`/userPinCodes/settings/${module}`)
}

export default getUsersPinCodesSettings
